import { BACKEND_URL, FREE_BACKEND_CONFIG } from "@/config/runtime";

let wakeIntervalId = null;
let lastWakeAt = 0;

export async function wakeBackend({ force = false, reason = "app" } = {}) {
  if (!BACKEND_URL || !FREE_BACKEND_CONFIG.wakeLoopEnabled) return false;

  const now = Date.now();
  if (!force && now - lastWakeAt < FREE_BACKEND_CONFIG.minWakeGapMs) return true;
  lastWakeAt = now;

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), FREE_BACKEND_CONFIG.wakeTimeoutMs);

  try {
    const healthUrl = new URL(`${BACKEND_URL}${FREE_BACKEND_CONFIG.healthPath}`);
    healthUrl.searchParams.set("wake", reason);
    healthUrl.searchParams.set("t", String(now));

    const response = await fetch(healthUrl.toString(), {
      method: "GET",
      cache: "no-store",
      signal: controller.signal,
    });
    return response.ok;
  } catch (error) {
    return false;
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export function startBackendWakeLoop() {
  if (!FREE_BACKEND_CONFIG.wakeLoopEnabled) return;
  wakeBackend({ force: true, reason: "app-start" });
  if (wakeIntervalId) return;

  wakeIntervalId = window.setInterval(() => {
    if (document.visibilityState === "visible") {
      wakeBackend({ reason: "visible-loop" });
    }
  }, FREE_BACKEND_CONFIG.wakeIntervalMs);
}

export function stopBackendWakeLoop() {
  if (wakeIntervalId) {
    window.clearInterval(wakeIntervalId);
    wakeIntervalId = null;
  }
}
